import { Component, OnInit, ViewChild, Input } from "@angular/core";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { CommonService } from "src/app/core/services/common.service";
import { BdspCustomListService } from "src/app/core/services/bdsp/bdsp-custom-list";
import { BdspStaticService } from "src/app/core/services/bdsp/bdsp-static.service";
import { trgtOperationOptions } from "src/app/models/common";
import { STATIC_LISTING_MAPS } from "src/app/models/bdsp/bdsp-line-item";

@Component({
  selector: "app-bdsp-inventory-listing",
  templateUrl: "./bdsp-inventory-listing.component.html",
  styleUrls: ["./bdsp-inventory-listing.component.scss"],
})
export class BdspInventoryListingComponent implements OnInit {
  @Input() stepInput: any;

  dataSourceList: MatTableDataSource<any>;
  @ViewChild("listPaginator") paginatorlist: MatPaginator;
  @ViewChild("listSort") sortlist: MatSort;
  displayColumnLevel: string[] = ["checkbox", "name", "id", "level"];
  listPageLength;

  allListItems: Array<any> = [];
  constListItems: Array<any> = [];
  totalItemsCount: number;
  isMulAction: boolean = false;

  searchParams = {};
  globalParams = {};
  trgtOperations: Array<any> = [];
  bulkEditAction: string = "";

  selectedLists: Array<any> = [];
  selectedAction: "include" | "exclude" = "include";

  actions = ["include", "exclude"];
  actionMapping = {
    content_category: "content_category_action",
    domains: "domain_list_action",
    app_bundle: "app_bundle_list_action",
    lat_long_list: "lat_long_list_action",
    ad_position: "ad_position_action",
    interstitial_type: "interstitial_type_action",
    language: "language_action",
  };

  apiTypeMapping = {
    domains: "domain",
    app_bundle: "app_bundle",
    lat_long_list: "lat_long"
  };
  keyToCompare: string = "";

  // API end-point type value mapping
  staticDBTypeMapping = {
    operating_system: "os",
    content_category: "content-categories",
    ads_txt: "ads-txt",
    language: "languages",
    native_layout: "native-layout",
  };

  // API end-point response key mapping
  staticDBResMapping = {
    operating_system: "os",
    content_category: "content_categories",
    ads_txt: "ads_txt",
    language: "languages",
    native_layout: "native_layout",
  };

  // Static DB Items
  staticDBItems: Set<any> = new Set([
    "operating_system",
    "content_category",
    "language",
    "ads_txt",
    "native_layout",
  ]);

  staticListing: Set<any> = new Set([
    "ad_position",
    "interstitial_type",
  ]);

  // Static DB keys to compare during add/remove
  staticDBKeyToCompare = {
    operating_system: "key",
    content_category: "key",
    ads_txt: "id",
    language: "key",
    native_layout: "id",
  };

  constListing: Set<any> = new Set(["video", "audio"]);

  constructor(
    private bdspCustomListService: BdspCustomListService,
    private bdspStaticService: BdspStaticService,
    private commonService: CommonService
  ) {}

  // Function to format listing data as per the MAP, i.e, ad_position, interstitial_type
  formatStaticListingData(selectedLists = [], type) {
    const list = STATIC_LISTING_MAPS[type];
    if (!Array.isArray(selectedLists) || !list) {
    return [];
    }
    return list.filter(item => selectedLists.includes(item.key));
  }

  ngOnInit(): void {
    this.globalParams = this.stepInput.globalParams;
    //If @Input type is static listing type, then call the formatting function.
    this.selectedLists = this.staticListing.has(this.stepInput.type) 
                        ? this.formatStaticListingData(this.stepInput.selectedLists, this.stepInput.type) 
                        : this.stepInput.selectedLists;
    this.selectedAction = this.stepInput.selectedAction;
    this.trgtOperations = trgtOperationOptions;
    this.bulkEditAction = this.stepInput.bulkEditAction;
    this.isMulAction = this.stepInput.isMulAction;

    // If Video tab
    if (this.constListing.has(this.stepInput.key)) {
      this.updateStaticList();
    }

    // Inventory tab listing
    else {
      if (this.staticDBItems.has(this.stepInput.type)) {
        this.displayColumnLevel = ["checkbox", "name"];
        this.keyToCompare = this.staticDBKeyToCompare[this.stepInput.type];
      } else {
        this.keyToCompare = "id";
      }
      if(!this.staticListing.has(this.stepInput.type)) {
        this.getAllList();
      } else {
        this.updateStaticList();
      }
    }
  }

  updateStaticList(){
    this.allListItems = this.constListItems = JSON.parse(
        JSON.stringify(this.stepInput.listing)
      );
      this.listPageLength = this.totalItemsCount = this.allListItems.length;
      this.displayColumnLevel = ["checkbox", "name"];
      this.keyToCompare = "key";

      if (this.selectedLists.length > 0) {
        let selectedListCount = 0;
        this.selectedLists.map((ele) => {
          this.allListItems = this.allListItems.filter(
            (item) => item[this.keyToCompare] != ele[this.keyToCompare]
          );
          selectedListCount += 1;
          this.listPageLength = this.totalItemsCount - selectedListCount;
          this.updateListTable();
        });
      }

      this.updateListTable();
  }

  updateListTable() {
    this.dataSourceList = new MatTableDataSource(this.allListItems);
    if (this.constListing.has(this.stepInput.key)) {
      this.listPageLength = this.totalItemsCount = this.allListItems.length;
    }
    this.dataSourceList.paginator = this.paginatorlist;
    this.dataSourceList.sort = this.sortlist;
    this.dataSourceList._updatePaginator(this.listPageLength);
  }

  getAllList(params = {}, start_element?, num_elements?, merge = false) {
    if (start_element || num_elements) {
      params["start_element"] = start_element;
      params["num_elements"] = num_elements;
    }

    if (!this.staticDBItems.has(this.stepInput.type)) {
      params["type"] = this.apiTypeMapping[this.stepInput.type];
      params = { ...params, ...this.globalParams, ...this.searchParams };
    } else {
      if (this.searchParams["search_term"]) {
        params["fields"] = "name";
        params["name"] = this.searchParams["search_term"];
      }
      params = { ...params, ...this.globalParams };
    }

    let service;
    service = this.staticDBItems.has(this.stepInput.type)
      ? this.bdspStaticService.getStaticData(
          this.staticDBTypeMapping[this.stepInput.type],
          start_element,
          num_elements,
          params
        )
      : this.bdspCustomListService.list(params);

    service.subscribe((res) => {
      if (merge) {
        this.allListItems = this.allListItems.concat(
          this.staticDBItems.has(this.stepInput.type)
            ? res[this.staticDBResMapping[this.stepInput.type]]
            : res.data
        );
        this.updateListTable();
      } else {
        this.allListItems = this.staticDBItems.has(this.stepInput.type)
          ? res[this.staticDBResMapping[this.stepInput.type]]
          : res.data;
        this.listPageLength = this.totalItemsCount = res.count;
        this.updateListTable();
      }

      if (this.selectedLists.length > 0) {
        let selectedListCount = 0;
        this.selectedLists.map((ele) => {
          this.allListItems = this.allListItems.filter(
            (item) => item[this.keyToCompare] != ele[this.keyToCompare]
          );
          selectedListCount += 1;
          this.listPageLength =
            params["search_term"] || params["name"]
              ? this.allListItems.length
              : this.totalItemsCount - selectedListCount;
          this.updateListTable();
        });
      }
    });
  }

  proceed() {
    this.commonService.setIvtData({
      list: this.selectedLists,
      action: this.selectedAction,
      type: this.stepInput.type,
      bulkEditAction: this.bulkEditAction,
      key: this.stepInput.key,
    });
  }

  updateAction(action) {
    this.selectedAction = action;
    this.proceed();
  }

  searchList(event) {
    // For constant listing and static listing, only filter the list, skip API call
    if (this.constListing.has(this.stepInput.key) || this.staticListing.has(this.stepInput.type)) {
      let filter = event.target.value.toLowerCase();
      this.allListItems = this.constListItems.filter((ele) =>
        ele.name.toLowerCase().includes(filter.toLowerCase())
      );
      this.selectedLists.map((ele) => {
        this.allListItems = this.allListItems.filter(
          (item) => item[this.keyToCompare] != ele[this.keyToCompare]
        );
        this.updateListTable();
      });
      this.updateListTable();
    } else {
      let filter = event.target.value.toLowerCase();
      this.dataSourceList.filter = filter.trim().toLowerCase();
      this.searchParams["search_term"] = filter;
      this.getAllList();
    }
  }

  removeAllSelectedLists() {
    this.selectedLists.length = 0;
    if (this.constListing.has(this.stepInput.key) || this.staticListing.has(this.stepInput.type)) {
      this.allListItems = JSON.parse(JSON.stringify(this.constListItems));
      this.listPageLength = this.totalItemsCount = this.allListItems.length;
      this.updateListTable();
    } else {
      this.getAllList();
    }
    this.proceed();
  }

  addListItem(row) {
    if (this.stepInput.isDlvMod && this.selectedLists.length == 1) {
      this.allListItems.unshift(this.selectedLists[0]);
      this.selectedLists = [];
      this.listPageLength += 1;
    }

    if (this.isMulAction) {
      row = { ...row, [this.actionMapping[this.stepInput.type]]: "include" };
    }
    this.allListItems = this.allListItems.filter(
      (ele) => ele[this.keyToCompare] != row[this.keyToCompare]
    );
    this.selectedLists.push(row);
    this.listPageLength = this.listPageLength - 1;
    this.updateListTable();
    this.proceed();
  }

  addAllListItems() {
    this.allListItems.forEach((list_item) => {
      this.addListItem(list_item);
    });
    this.listPageLength = 0;
    this.updateListTable();
    this.proceed();
  }

  removeSelectedItem(row) {
    this.selectedLists = this.selectedLists.filter(
      (ele) => ele[this.keyToCompare] != row[this.keyToCompare]
    );
    this.listPageLength = this.listPageLength + 1;
    this.allListItems.unshift(row);
    this.updateListTable();
    this.proceed();
  }

  checkOperation() {
    if (this.bulkEditAction == "remove_all") {
      this.removeAllSelectedLists();
    }
  }

  handlePageEvent(event: PageEvent) {
    // Skip API calls for staticListing items
    if (this.staticListing.has(this.stepInput.type)) {
      return;
    }
      let requested_page = event.pageSize * (event.pageIndex + 1);
      let num_elements = 100;
      if (requested_page > this.allListItems.length) {
        let selectedListCount = 0;
        selectedListCount = this.selectedLists.length;
        let params = {};
        let start_element =
          event.pageSize >= this.allListItems.length
            ? event.pageSize
            : this.allListItems.length + selectedListCount;
        this.getAllList(params, start_element, num_elements, true);
    }
  }
}
